import { ApiQueryBuilder } from "@/hooks/use-api-query";
import { QueryKey } from "@/utils/query-key";

interface Input {
    invitationId?: string
}

interface Output {
    challenge: string
    credentialId: string
}

export const GetRootAdminChallenge: ApiQueryBuilder<Output, Input | void, [string | undefined]> = ({ invitationId } = {}) => ({
    queryKey: [QueryKey.RootAdminChallenge, invitationId],
    queryFn: async (apiClient) => {
        const searchParams = new URLSearchParams()
        if (invitationId) {
            searchParams.set('invitation-id', invitationId)
        }
        const searchParamsString = searchParams.toString()
        const response = await apiClient.get<Output>(`/root-admins/auth/challenge?${searchParamsString}`)
        return response.data
    }
})